<template>
  <div class="allocation-of-fte-table">
    <div class="allocation-of-fte-table-header">
      <InputLabel value="Allocation of FTE" font-size="22"></InputLabel>
    </div>
    <el-table
      class="allocation-table"
      :data="tableData"
      empty-text="No Data Available"
      header-cell-class-name="table-header-dark"
      :cell-class-name="tableCellClassName">
      <el-table-column
        label="ORG ID"
        show-overflow-tooltip
        label-class-name="column-header-double"
        width="350">
        <template slot-scope="scope">
          {{ getOrgDisplay(scope) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Appropriated"
        header-align="center"
        label-class-name="table-header-light">
        <el-table-column
          label="Perm"
          header-align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.fteAppropriatedPerm | decimal }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Temp"
          header-align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.fteAppropriatedTemp | decimal }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="Unappropriated"
        header-align="center"
        label-class-name="table-header-light">
        <el-table-column
          label="Temp"
          header-align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.fteUnappropriatedTemp | decimal }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import InputLabel from '../misc/InputLabel.vue';

export default {
  name: 'AllocationOfFteTable',
  components: {
    InputLabel,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tableColumns: ['orgId', 'fteAppropriatedPerm', 'fteAppropriatedTemp', 'fteUnappropriatedTemp'],
    };
  },
  methods: {
    tableCellClassName({
      // eslint-disable-next-line no-unused-vars
      row, column, rowIndex, columnIndex,
    }) {
      const className = ['allocation-cell'];
      if (columnIndex !== 0
          && columnIndex !== this.tableColumns.length - 1
          && rowIndex < this.tableData.length - 1) {
        className.push('empty-cell');
      }
      if (columnIndex === 0
        || columnIndex === this.tableColumns.length - 1
        || rowIndex >= this.tableData.length - 1) {
        className.push('bold-cell');
      }
      if (rowIndex >= this.tableData.length - 1) {
        className.push('black-text-cell');
      }
      return className.join(' ');
    },
    getOrgDisplay(scope) {
      const { orgId } = scope.row;
      return scope.row.orgName ? `${orgId}: ${scope.row.orgName}` : orgId;
    },
  },
};
</script>

<style scoped lang="scss">
  .allocation-of-fte-table {
    .allocation-of-fte-table-header {
      height: 40px;
      margin-bottom: 10px;
    }
  }
</style>
